interface Props {
  onLogin: () => void;
  error: string;
}

export function LoginView({ onLogin, error }: Props) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <div className="w-full max-w-sm text-center">
        <div className="mb-1">
          <span className="text-[11px] tracking-[0.18em] uppercase text-[var(--text-muted)]">
            agentos
          </span>
        </div>
        <h1
          className="text-[36px] mb-12 tracking-[0.06em]"
          style={{
            fontFamily: 'var(--font-heading)',
            fontWeight: 300,
            color: 'var(--text-body)',
          }}
        >
          issues
        </h1>

        {error && (
          <div
            className="mb-6 p-3 text-[12px] text-left border-l-2"
            style={{
              borderColor: 'var(--color-error)',
              background: 'var(--color-error-bg)',
              color: 'var(--color-error)',
            }}
          >
            {error}
          </div>
        )}

        <button className="btn-primary w-full" onClick={onLogin}>
          Sign in with Google
        </button>

        <div className="mt-10 text-[10px] uppercase tracking-[0.18em] text-[var(--text-muted)]">
          issue-tracking · federation
        </div>
      </div>
    </div>
  );
}
